import { Component } from '@angular/core';

@Component({
    selector: 'app-aside',
    templateUrl: './app-aside.component.html',
    standalone: false
})
export class AppAsideComponent {

  constructor() { }
}
